import { render, staticRenderFns } from "./FlightPaperPlaneWithConfetti.vue?vue&type=template&id=7e084b14&scoped=true&lang=pug&"
import script from "./FlightPaperPlaneWithConfetti.vue?vue&type=script&lang=ts&"
export * from "./FlightPaperPlaneWithConfetti.vue?vue&type=script&lang=ts&"
import style0 from "./FlightPaperPlaneWithConfetti.vue?vue&type=style&index=0&id=7e084b14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e084b14",
  null
  
)

export default component.exports